import logoAsset from '@/assets/td-logo.png.asset.json';

export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <img
      src={logoAsset.url}
      alt="TurkeyDrive"
      width={size}
      height={size}
      className="block"
      style={{ width: size, height: size }}
    />
  );
}

export function Logo({ showTagline = true }: { showTagline?: boolean }) {
  return (
    <div className="flex min-w-0 items-center gap-2 md:gap-3">
      <BrandMark size={36} />
      <div className="flex min-w-0 flex-col gap-px">
        <div className="font-brand text-[18px] font-extrabold leading-none tracking-[-.02em] md:text-[22px]">
          <span className="text-td-dark">Turkey</span><span className="text-td-teal">Drive</span>
        </div>
        {showTagline && (
          <div className="truncate whitespace-nowrap text-[11px] font-medium tracking-[.01em] text-[#8A9E9C]">
            Почувствуй себя в Турции как дома
          </div>
        )}
      </div>
    </div>
  );
}
